import React, { Component } from "react";
import { Modal } from "antd";
import moment from "moment";
import {
  FETAL_MOVEMENT,
  PRESENTATION,
  RELATIONSHIP_TO_PP_BRIM,
} from "../../../utils/constant";

class PreviousMotherHistoryModal extends Component {
  getValue = (value, options = null) => {
    if (value === undefined || value === null || value === "") return "-";
    if (options && options[value] !== undefined) return options[value];
    return value;
  };

  formatDate = (row) => {
    const date = row?.updatedAt || row?.createdAt;
    return date && moment(date).isValid()
      ? moment(date).format("D MMM, YYYY | h:mm A")
      : "-";
  };

  getSavedByName = (row) => row?.saved_by_doctor_name || row?.added_by_name || "-";

  getSavedById = (row) => row?.saved_by_doctor_id || row?.created_by || row?.updated_by || "-";

  renderMotherParameters = () => {
    const rows = Array.isArray(this.props.motherParameters)
      ? [...this.props.motherParameters].sort((a, b) => (b.id || 0) - (a.id || 0))
      : [];

    if (rows.length === 0) {
      return <div className="text-center py-3">No mother-parameter history available.</div>;
    }

    return (
      <div className="table-responsive">
        <table className="table table-bordered table-sm mb-0">
          <thead>
            <tr>
              <td>DATE &amp; TIME</td>
              <td>SAVED BY</td>
              <td>POG (WEEKS)</td>
              <td>WEIGHT (KG)</td>
              <td>BP (MMHG)</td>
              <td>PULSE RATE (MIN)</td>
              <td>FUNDAL HT (CM)</td>
              <td>EDEMA</td>
              <td>PALLOR</td>
              <td>CERVIX EXAM</td>
              <td>PRETERM LABOUR</td>
              <td>REMARKS</td>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={row.id || index}>
                <td>{this.formatDate(row)}</td>
                <td>{this.getSavedByName(row)}</td>
                <td>{this.getValue(row.pog)}</td>
                <td>{this.getValue(row.weight)}</td>
                <td>{this.getValue(row.blood_pressure)}</td>
                <td>{this.getValue(row.pulse_rate)}</td>
                <td>{this.getValue(row.fundal_height)}</td>
                <td>{this.getValue(row.edema)}</td>
                <td>{this.getValue(row.pallor)}</td>
                <td>{this.getValue(row.cervix_exam)}</td>
                <td>{this.getValue(row.preterm_labour)}</td>
                <td>{this.getValue(row.mother_remarks)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  renderMotherFetus = () => {
    const rows = Array.isArray(this.props.motherFetusData) ? this.props.motherFetusData : [];
    if (rows.length === 0) {
      return <div className="text-center py-3">No mother-fetus history available.</div>;
    }

    const grouped = rows.reduce((result, row) => {
      const fetusNo = row.fetus_no || 1;
      if (!result[fetusNo]) result[fetusNo] = [];
      result[fetusNo].push(row);
      return result;
    }, {});

    return Object.keys(grouped)
      .sort((a, b) => Number(a) - Number(b))
      .map((fetusNo) => {
        const fetusRows = [...grouped[fetusNo]].sort((a, b) => (b.id || 0) - (a.id || 0));
        return (
          <div key={fetusNo} className="mb-4">
            <h6 className="font-weight-bold mb-2">Fetus {fetusNo}</h6>
            <div className="table-responsive">
              <table className="table table-bordered table-sm mb-0">
                <thead>
                  <tr>
                    <td>DATE &amp; TIME</td>
                    <td>SAVED BY</td>
                    <td>FETAL MOVEMENT</td>
                    <td>FHR (B/MIN)</td>
                    <td>PRESENTATION</td>
                    <td>RELATION OF PP TO BRIM</td>
                    <td>HEAD CC (CM)</td>
                    <td>ABDOMINAL CC (CM)</td>
                    <td>FEMUR LENGTH (CM)</td>
                  </tr>
                </thead>
                <tbody>
                  {fetusRows.map((row, index) => (
                    <tr key={row.id || index}>
                      <td>{this.formatDate(row)}</td>
                      <td>{this.getSavedByName(row)}</td>
                      <td>{this.getValue(row.fetal_movement, FETAL_MOVEMENT)}</td>
                      <td>{this.getValue(row.fetal_heart_rate)}</td>
                      <td>{this.getValue(row.presentation, PRESENTATION)}</td>
                      <td>{this.getValue(row.relationship_of_pp_to_brim, RELATIONSHIP_TO_PP_BRIM)}</td>
                      <td>{this.getValue(row.head_cc)}</td>
                      <td>{this.getValue(row.abdominal_cc)}</td>
                      <td>{this.getValue(row.femur_length)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      });
  };

  render() {
    const { visible, onClose, type } = this.props;
    const isMother = type === "mother";
    return (
      <Modal
        title={isMother ? "Previous Mother Parameter Details" : "Previous Fetus Details"}
        visible={visible}
        onCancel={onClose}
        footer={null}
        width={1800}
        destroyOnClose
        bodyStyle={{ paddingBottom: 8 }}
      >
        {isMother ? this.renderMotherParameters() : this.renderMotherFetus()}
      </Modal>
    );
  }
}

export default PreviousMotherHistoryModal;
